import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useGet from "../../hooks/useGet";
import { hasData } from "../../utils/handler.utils";
import { spinClaimHistoryTableColumns } from "../../utils/reactTableColumns";
import ListPerPage from "../ReactTables/ListPerPage";
import Pagination from "../ReactTables/Pagination";
import ReactTable from "../ReactTables/ReactTable";
import UiHandler from "../UiHandler";

function SpinClaimHistory() {
  const { user_id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [listPerPage, setListPerPage] = useState(10);
  const [urlToFetch, setUrlToFetch] = useState(
    `admin/spin-statistics/user/${user_id}/history?page=${currentPage}&limit=${listPerPage}`
  );
  const [historyData, loading, error] = useGet(urlToFetch);

  useEffect(() => {
    setUrlToFetch(
      `admin/spin-statistics/user/${user_id}/history?page=${currentPage}&limit=${listPerPage}`
    );
  }, [user_id, currentPage, listPerPage]);

  const user = historyData?.user;
  const claims = historyData?.data || [];
  const totalClaim = historyData?.total_claim || 0;

  return (
    <section className="relative container_admin">
      <div className="bg-white overflow-hidden rounded">
        <div className="px-6 py-3 border-b border-gray-200 flex items-center justify-between flex-wrap gap-3">
          <div>
            <h3 className="text-lg font-bold text-black">Spin Claim History</h3>
            <p className="text-sm text-gray-600">
              User id: {user_id} | Total claim: {totalClaim}
            </p>
          </div>

          <Link
            className="cstm_btn_small !bg-slate-600 hover:!bg-slate-700"
            to="/spin/statistics/users"
          >
            Back to leaderboard
          </Link>
        </div>

        {user && (
          <div className="px-6 py-3 border-b border-gray-200 text-sm text-gray-700 flex flex-wrap gap-x-6 gap-y-2">
            <p>
              <span className="font-semibold">Username:</span>{" "}
              {user.username || "---"}
            </p>
            <p>
              <span className="font-semibold">Email:</span> {user.email || "---"}
            </p>
            <p>
              <span className="font-semibold">Phone:</span> {user.phone || "---"}
            </p>
          </div>
        )}

        <div>
          <div className="relative min-h-[100px]">
            <UiHandler data={claims} loading={loading} error={error} />
            {hasData(claims, loading, error) && (
              <ReactTable
                tableId="spin_claim_history_table"
                columns={spinClaimHistoryTableColumns}
                data={claims}
              />
            )}
          </div>

          {Array.isArray(claims) && (
            <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between px-6 py-4 border-t border-gray-200 gap-4">
              <Pagination
                setCurrentPage={setCurrentPage}
                page={currentPage}
                totalList={totalClaim}
                listPerPage={listPerPage}
              />
              <ListPerPage
                listPerPage={listPerPage}
                setListPerPage={setListPerPage}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default SpinClaimHistory;
